export const ReturnedReason = ({ history, testid }) => {
  const r = [...(history || [])].reverse().find((h) => h.action === "returned" || h.action === "rejected");
  if (!r) return null;
  return <p className="text-xs text-red-800 mt-1" data-testid={testid}>Returned by {r.user_name}{r.reason ? `: ${r.reason}` : ""}</p>;
};
